import {
    Box,
    VStack,
    Text,
    Input,
    Button,
    Image,
    Select,
    createListCollection,
} from "@chakra-ui/react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import routes from "../../../../routes";
import Logo from "../../../../assets/logo.png";
import AttachmentUpload from "../../../../components/AttachmentUpload";
import FormLabel from "../../components/FormLabel";
import AppCheckbox from "../../../../components/AppCheckBox";
import {
    useDispatch,
    useSelector,
} from "react-redux";

import {
    registerDriverPartnerAction,
} from "../../../../state/actions/driverPartnerActions";

import {
    toaster,
} from "../../../../components/toaster";

import ActivityToast from "../../../../components/ActivityToast";

const paymentMethods =
    createListCollection({
        items: [
            {
                label:
                    "Bank Transfer",
                value:
                    "Bank",
            },
            {
                label:
                    "Orange Money",
                value:
                    "OrangeMoney",
            },
            {
                label:
                    "MyZaka",
                value:
                    "MyZaka",
            },
            {
                label:
                    "Smega",
                value:
                    "Smega",
            },
            {
                label:
                    "Other",
                value:
                    "Other",
            },
        ],
    });

const referralSources = createListCollection({
    items: [
        {
            label: "Facebook",
            value: "facebook",
        },
        {
            label: "Instagram",
            value: "instagram",
        },
        {
            label: "Friend",
            value: "friend",
        },
        {
            label: "Website",
            value: "website",
        },
        {
            label: "Advertisement",
            value: "advertisement",
        },
        {
            label: "Other",
            value: "other",
        },
    ],
});

const CompleteProfileForm = () => {
    const navigate = useNavigate();
    const dispatch =
    useDispatch();


const {
    loading,
} = useSelector(
    (state) =>
        state.driverPartner
);

    const [paymentMethod, setPaymentMethod] =
        useState("");

    const [paymentAccount, setPaymentAccount] =
        useState("");
    const [accountName, setAccountName] =
    useState("");
    const [accountNumber, setAccountNumber] =
        useState("");
    const [branch, setBranch] =
        useState("");
    const [branchCode, setBranchCode] =
        useState("");
    const [referralSource, setReferralSource] =
        useState("");
    const [agreement, setAgreement] =
        useState(false);
    const [identityProof, setIdentityProof] =
        useState([]);
    const [profileImage, setProfileImage] =
        useState([]);

const handleSubmit = async () => {

const result =
    await dispatch(
        registerDriverPartnerAction({
            payment_method:
                paymentMethod,

            payment_account:
                paymentAccount,

            account_name:
                accountName,

            account_number:
                accountNumber,

            branch:
                branch,

            branch_code:
                branchCode,

            agreement_accepted:
                true,

            referral_source:
                referralSource,

            identity_proof:
                identityProof?.[0]?.file,

            profile_image:
                profileImage?.[0]?.file,
        })
    );

    if (
        result?.success
    ) {
        toaster.create({
            render: () => (
                <ActivityToast
                    type="success"
                    title="Application Submitted"
                    description="Your Driver Partner application has been submitted successfully."
                    timestamp="Just now"
                />
            ),
        });

        setTimeout(() => {
            navigate(
                routes.fillPersonalDetails
            );
        }, 1000);
    } else {
        toaster.create({
            render: () => (
                <ActivityToast
                    type="error"
                    title="Registration Failed"
                    description={
                        result?.error ||
                        "Failed to submit your application."
                    }
                    timestamp="Just now"
                />
            ),
        });
    }
};

    return (
        <Box
            p={{
                base: 6,
                md: 10,
                lg: 20,
            }}
            overflowY="auto"
            h="100vh"
        >
            <Box
                textAlign="center"
                mb={10}
            >
                <Image
                    src={Logo}
                    h="52px"
                    mx="auto"
                    mb={12}
                />

                <Text
                    fontSize="48px"
                    fontWeight="700"
                    color="#071D54"
                >
                    Complete Your Profile
                </Text>

                <Text
                    mt={3}
                    color="gray.600"
                    maxW="500px"
                    mx="auto"
                >
                    Complete your Driver Partner
                    application before submitting it
                    for approval.
                </Text>
            </Box>

            <VStack gap={6} align="stretch">
                {/* Payment Method */}
                <Box>
                <FormLabel>
                    Payment Method
                </FormLabel>

                <Select.Root
                    collection={paymentMethods}
                    value={[paymentMethod]}
                    onValueChange={(e) =>
                        setPaymentMethod(
                            e.value[0]
                        )
                    }
                >
                    <Select.Trigger>
                        <Select.ValueText placeholder="Select payment method" />
                        <Select.Indicator />
                    </Select.Trigger>

                    <Select.Content>
                        {paymentMethods.items.map(
                            (item) => (
                                <Select.Item
                                    key={item.value}
                                    item={item}
                                >
                                    {item.label}
                                </Select.Item>
                            )
                        )}
                    </Select.Content>
                </Select.Root>
            </Box>
                <Box>
                    <FormLabel>
                        {
                            paymentMethod === "Bank"
                                ? "Bank Name"
                                : "Payment Account"
                        }
                    </FormLabel>

                    <Input
                        size="lg"
                        placeholder={
                            paymentMethod === "Bank"
                                ? "Bank Name"
                                : "Mobile number or wallet number"
                        }
                        value={paymentAccount}
                        onChange={(e) =>
                            setPaymentAccount(
                                e.target.value
                            )
                        }
                    />
                </Box>

                {paymentMethod ===
                    "Bank" && (
                    <>
                        <Box>
                            <FormLabel>
                                Account Name
                            </FormLabel>

                            <Input
                                size="lg"
                                placeholder="Account holder name"
                                value={
                                    accountName
                                }
                                onChange={(e) =>
                                    setAccountName(
                                        e.target.value
                                    )
                                }
                            />
                        </Box>

                        <Box>
                            <FormLabel>
                                Account Number
                            </FormLabel>

                            <Input
                                size="lg"
                                placeholder="Bank account number"
                                value={
                                    accountNumber
                                }
                                onChange={(e) =>
                                    setAccountNumber(
                                        e.target.value
                                    )
                                }
                            />
                        </Box>

                        <Box>
                            <FormLabel>
                                Branch
                            </FormLabel>

                            <Input
                                size="lg"
                                placeholder="Branch name"
                                value={branch}
                                onChange={(e) =>
                                    setBranch(
                                        e.target.value
                                    )
                                }
                            />
                        </Box>

                        <Box>
                            <FormLabel>
                                Branch Code
                                (Optional)
                            </FormLabel>

                            <Input
                                size="lg"
                                placeholder="Branch code"
                                value={
                                    branchCode
                                }
                                onChange={(e) =>
                                    setBranchCode(
                                        e.target.value
                                    )
                                }
                            />
                        </Box>
                    </>
                )}

                {/* Identity */}

                <AttachmentUpload
                    title="Identity Proof"
                    description="Attach a clear scan showing both the front and back of your ID in one file."
                    files={identityProof}
                    onChange={setIdentityProof}
                    maxFiles={1}
                    accept=".jpg,.jpeg,.png,.pdf"
                />
                <Text
                mt={-4}
                fontSize="sm"
                color="orange.600"
                fontStyle="italic"
                >
                For National ID cards, please combine the front
                and back into a single image or PDF. Do not upload
                the front side only.
            </Text>

                {/* Profile */}

                <AttachmentUpload
                    title="Profile Photo"
                    description="Upload a clear passport-style photo of yourself."
                    files={profileImage}
                    onChange={setProfileImage}
                    maxFiles={1}
                    accept=".jpg,.jpeg,.png"
                /> 

<Text
    mt={-4}
    fontSize="sm"
    color="orange.600"
    fontStyle="italic"
>
    Please upload a clear passport-style photo showing your face. Avoid filters, group photos,
    and full-body pictures.
</Text>

                {/* Referral */}

                <Box>
                     <FormLabel>
                        Referral Source
                    </FormLabel>

                    <Select.Root
                        collection={referralSources}
                        value={[referralSource]}
                        onValueChange={(e) =>
                            setReferralSource(
                                e.value[0]
                            )
                        }
                    >
                        <Select.Trigger>
                            <Select.ValueText placeholder="How did you hear about Mogoma?" />
                        </Select.Trigger>

                        <Select.Content>
                            {referralSources.items.map(
                                (item) => (
                                    <Select.Item
                                        key={
                                            item.value
                                        }
                                        item={item}
                                    >
                                        {
                                            item.label
                                        }
                                    </Select.Item>
                                )
                            )}
                        </Select.Content>
                    </Select.Root>
                </Box>

             

               <Button
                size="lg"
                bg="#2453FF"
                color="white"
                loading={loading}
                loadingText="Submitting..."
                _hover={{
                    bg: "#1E46D8",
                }}
                disabled={
                    !paymentMethod ||
                    !paymentAccount ||
                    identityProof.length === 0 ||
                    (
                        paymentMethod === "Bank" &&
                        (
                            !accountName ||
                            !accountNumber ||
                            !branch
                        )
                    )
                }
                onClick={handleSubmit}
            >
                Complete Registration
            </Button>
            </VStack>
        </Box>
    );
};

export default CompleteProfileForm;